<template>
  <div style="width: 98%; height: 98%">
    <div class="status-container">
      <el-row>
        <el-col :span="3" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目年份：">
            <el-date-picker v-model="project_year" type="years" value-format="YYYY" placeholder="选择年份" @change="getBusData" style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="3" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目名称：">
            <el-select v-model="project_id" placeholder="请选择" clearable @change="getBusData">
              <el-option v-for="item in projectList" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目状态：">
            <el-select v-model="project_status" placeholder="请选择" clearable @change="getBusData">
              <el-option v-for="item in projectStatusList" :key="item.value" :label="item.name"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" :offset="1" style="text-align: right;">
          <span class="color-block processed"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">已完成</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block pending"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">待处理</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block unclaimed"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">待领取</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block expired"></span>
        </el-col>
        <el-col :span="1" style="text-align: left;">
          <span class="status-text">已逾期</span>
        </el-col>
      </el-row>
    </div>
    <el-row style="padding-top: 10px;">
      <template v-for="data in busData">
        <el-col :span="24"
                style="font-size: large; line-height: 50px;text-align: center;padding-left: 20%;width:100%;margin-bottom: 15px">
          <el-row>
            <el-col :span="19" style="font-size: large; line-height: 50px;text-align: center;width:100%;">
              <el-row class="project-name">
                <el-col :span="6" >{{ data.start_year }}</el-col>
                <el-col :span="12" style="text-align: center;">{{ data.project_name }}</el-col>
                <el-col :span="4" style="text-align: right;">{{ data.project_status_name }}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3" class="val">成员名称</el-col>
            <el-col :span="4" class="val6">任务</el-col>
            <el-col :span="3" class="val">需求</el-col>
            <el-col :span="3" class="val6">BUG</el-col>
            <el-col :span="3" class="val">工单</el-col>
            <el-col :span="3" class="val6">风险</el-col>
          </el-row>
          <el-row v-for="item in data.item_list" style="width: 100%;">
            <el-col :span="3" class="val1">{{ item.user_name }}</el-col>
            <el-col :span="1" class="val2">{{ item.task_processed_cnt }}</el-col>
            <el-col :span="1" class="val3">{{ item.task_pending_cnt }}</el-col>
            <el-col :span="1" class="val4">{{ item.task_expired_cnt }}</el-col>
            <el-col :span="1" class="val5">{{ item.task_unclaimed_cnt }}</el-col>
            <el-col :span="1" class="val2">{{ item.requirement_processed_cnt }}</el-col>
            <el-col :span="1" class="val3">{{ item.requirement_pending_cnt }}</el-col>
            <el-col :span="1" class="val5">{{ item.requirement_unclaimed_cnt }}</el-col>
            <el-col :span="1" class="val2">{{ item.bug_processed_cnt }}</el-col>
            <el-col :span="1" class="val3">{{ item.bug_pending_cnt }}</el-col>
            <el-col :span="1" class="val5">{{ item.bug_unclaimed_cnt }}</el-col>
            <el-col :span="1" class="val2">{{ item.issue_processed_cnt }}</el-col>
            <el-col :span="1" class="val3">{{ item.issue_pending_cnt }}</el-col>
            <el-col :span="1" class="val5">{{ item.issue_unclaimed_cnt }}</el-col>
            <el-col :span="1" class="val2">{{ item.risk_processed_cnt }}</el-col>
            <el-col :span="1" class="val3">{{ item.risk_pending_cnt }}</el-col>
            <el-col :span="1" class="val5">{{ item.risk_unclaimed_cnt }}</el-col>
          </el-row>
        </el-col>
      </template>
    </el-row>
  </div>

</template>

<script>

export default {
  name: "ProjectManage",
  data() {
    return {
      busData: [],
      projectList: [],
      project_id: '',
      project_year:[],
      project_status: ''
    }
  },

  computed: {
    projectStatusList() {
      return this.$store.getters['core/getDictList']('project_status');
    },
  },

  created() {
    this.getBusData();
    this.getProjectListByAdmin();
  },

  methods: {
    async getBusData() {
      let params = {
        project_year: this.project_year,
        project_id: this.project_id,
        project_status: this.project_status
      }
      this.busData = await this.$http('prjBoardService.getProjectManageBoard', params)
    },

    async getProjectListByAdmin() {
      this.projectList = await this.$http('prjBoardService.getChargeProjects')
    },


  }

}

</script>

<style lang="less" scoped>

.project-name {
  margin-bottom: 5px;
  color: #fff;
  font-size: 22px; /* 文字更大 */
  background-color: rgba(112,110,110,0.65);
}

.val {
  margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val1 {
  margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val2 {
  margin-bottom: 5px;
  background-color: rgba(13, 213, 46, 0.55);
  color: #fff;
}

.val3 {
  margin-bottom: 5px;
  background-color: #EA9C0BBA;
  color: #fff;
}

.val4 {
  margin-bottom: 5px;
  background-color: #FC02029D;
  color: #fff;
}

.val5 {
  margin-bottom: 5px;
  background-color: rgba(220, 216, 14, 0.71);
  color: #fff;
}

.val6 {
  margin-bottom: 5px;
  background-color: #CBA5EED8;
  color: #fff;
}

.status-container {
  padding-top: 20px; /* 增加内边距 */
  background-color: #f5f5f5; /* 背景色 */
  border-bottom: 1px solid #ddd; /* 底部边框 */
  position: sticky; /* 固定在页面顶部 */
  top: 0; /* 距离顶部为 0 */
  z-index: 100; /* 确保在最上层 */
}

.color-block {
  display: inline-block;
  width: 100%; /* 色块宽度 */
  height: 30px; /* 色块高度 */
  border-radius: 6px; /* 圆角 */
}

.processed {
  background-color: rgba(13, 213, 46, 0.55); /* 绿色 */
}

.pending {
  background-color: #EA9C0BBA; /* 橙色 */
}

.expired {
  background-color: #FC02029D; /* 红色 */
}

.unclaimed {
  background-color: rgba(220, 216, 14, 0.71); /* 黄色 */
}

.status-text {
  font-size: 18px; /* 文字更大 */
  font-weight: bold; /* 文字加粗 */
  color: #333; /* 文字颜色 */
  width: 80%; /* 文字宽度与色块一致 */
  text-align: left; /* 文字居中 */
  margin-left: 10px;
}

</style>